// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.data-filters-row {
  width: 50%;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
}
.data-filters-row .shop-dropdown {
  width: fit-content;
  min-width: 10rem;
  border-radius: 8px;
  border-color: #E0E4ED;
}

.shop-selected, .shop {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.shop-selected__details__name, .shop__details__name {
  font-size: 0.9rem;
  color: #4F5566;
}

.p-calendar .p-inputtext {
  width: fit-content;
  min-width: 10rem;
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/data-filters-row/data-filters-row.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;AACI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AACR;;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAIQ;EACI,iBAAA;EACA,cAAA;AAFZ;;AAOA;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;AAJJ","sourcesContent":[".data-filters-row{\n    width: 50%;\n    display: flex;\n    flex-direction: row;\n    gap:0.5rem;\n\n    .shop-dropdown{\n        width: fit-content;\n        min-width: 10rem;\n        border-radius: 8px;\n        border-color:#E0E4ED ;\n    }\n\n}\n\n.shop-selected, .shop{\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    &__details{\n        &__name{\n            font-size: 0.9rem;\n            color:#4F5566;\n        }\n    }\n}\n\n.p-calendar .p-inputtext{\n    width:fit-content;\n    min-width: 10rem;\n    border-radius: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
